import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';

export default function UsageRequestButton({
  status,
  openView,
  openCreate,
  buttonStyle = {},
  requestButtonText = 'Request Usage Rights',
  requestSentText = 'Usage Request Sent',
  negotiationText = 'Negotiation',
}) {
  switch (status) {
    case 'notsent':
      return (
        <ButtonComponent
          variant="text"
          textStyle={{
            padding: '0px',
            fontSize: '12px',
            ...buttonStyle,
          }}
          onClick={openCreate}>
          {requestButtonText}
        </ButtonComponent>
      );
    case 'pending':
      return (
        <ButtonComponent
          variant="success-text"
          textStyle={{
            padding: '0px',
            fontSize: '12px',
            ...buttonStyle,
          }}
          onClick={openView}>
          {requestSentText}
        </ButtonComponent>
      );
    case 'accepted':
      return (
        <ButtonComponent
          variant="success-text"
          textStyle={{
            padding: '0px',
            fontSize: '12px',
            ...buttonStyle,
          }}
          onClick={openView}>
          Approved
        </ButtonComponent>
      );
    case 'rejected':
      return (
        <ButtonComponent
          variant="danger-text"
          textStyle={{
            padding: '0px',
            fontSize: '12px',
            ...buttonStyle,
          }}
          onClick={openView}>
          Rejected
        </ButtonComponent>
      );
    case 'negotiation':
      return (
        <ButtonComponent
          variant="warning-text"
          textStyle={{
            padding: '0px',
            fontSize: '12px',
            ...buttonStyle,
          }}
          onClick={openView}>
          {negotiationText}
        </ButtonComponent>
      );
  }

  return <></>;
}
